import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faEnvelope as farEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import {
	faHeartCrack as fasHeartCrack,
	faEnvelope as fasEnvelope,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, List } from "bm-ui-kit";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export class ResultKo extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="text-center mt-2">
					<FontAwesomeIcon icon={fasHeartCrack} className="text-gold" size="5x" />
					<div className="h4 mb-0 text-white font-weight-bold">
						Sajnos nem vagy jogosult támogatás igénybevételére.
					</div>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<hr className="my-2 w-100" />
					<div className="d-flex block-with-icon">
						<div className="text-center px-2">
							<FontAwesomeIcon icon={farEnvelope} className="text-gold" size="5x" />
						</div>
						<div className="px-2 text-white text-block">
							A részleteket <strong className="text-nowrap">e-mailben</strong> fogjuk elküldeni számodra!
						</div>
					</div>
					<hr className="my-2 w-100" />
					<List itemStyle="tick" variant="gold" className="mt-2">
						<List.Item>
							<strong>Miért nem vagy</strong> most jogosult támogatásra?
						</List.Item>
						<List.Item>
							<strong>Hogyan lehetnél</strong> jogosult?
						</List.Item>
						<List.Item>
							<strong>Milyen egyéb</strong> finanszírozási lehetőségeid vannak?
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						variant="gold"
						icon={<FontAwesomeIcon icon={fasEnvelope} />}
						size="lg"
						className="text-uppercase"
					>
						Kérem a részleteket
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success result-page"]).join(" ");
	}

	protected getComponentName(): string {
		return "ResultKo";
	}
}
